<ul class="selection-list">
  <li class="list-item">
    <div class="list-item-content list-select-all" (click)="$event.stopPropagation(); toggleAll();">
      <div class="checkbox-wrapper">
        <input type="checkbox" [checked]="isAllSelected"/>
      </div>
      <div class="item-wrapper">
        <ng-container *ngTemplateOutlet="_selectAllDirective?.templateRef || defaultSelectAllTpl; context: getSelectAllContext()"></ng-container>
      </div>
    </div>
  </li>
  <hr class="horizontal-divider"/>
  <li class="list-item" *ngFor="let item of data">
    <div class="list-item-content" (click)="$event.stopPropagation(); toggle(item);">
      <div class="checkbox-wrapper">
        <input type="checkbox" [checked]="selectionModel.isSelected(item)"/>
      </div>
      <div class="item-wrapper">
        <ng-container *ngTemplateOutlet="_listItemDirective.templateRef; context: getItemContext(item)"></ng-container>
      </div>
    </div>
  </li>
</ul>


<ng-template #defaultSelectAllTpl>
  Select All
</ng-template>